export enum CalendarView {
  DAY_VIEW = 'timeGridDay',
  WEEK_MOBILE_VIEW = 'listWeek',
  WEEK_VIEW = 'timeGridWeek',
  MONTH_VIEW = 'dayGridMonth',
}
